import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useQueryClient } from "react-query";
import { useRouteMatch, useLocation, useHistory, Switch, Route, Redirect } from "react-router-dom";
import { newConfig as newConfigBPA } from "../../../config/buildingPermitConfig";

const getPath = (path, params) => {
  params && Object.keys(params).map(key => {
    path = path.replace(`:${key}`, params[key]);
  })
  return path;
}

const NewBuildingPermit = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const { pathname, state } = useLocation();
  const match = useRouteMatch();
  const history = useHistory();
  sessionStorage.removeItem("BPA_SUBMIT_APP");

  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("BUILDING_PERMIT", state?.edcrNumber ? { data: { scrutinyNumber: { edcrNumber: state?.edcrNumber } } } : {});

  const stateId = Digit.ULBService.getStateId();
  let { data: newConfig } = Digit.Hooks.obps.SearchMdmsTypes.getFormConfig(stateId, []);

  const currentPath = pathname.split("/").pop();
  const goNext = (skipStep) => {
    let { nextStep } = config.find((routeObj) => routeObj.route === currentPath);
    let redirectWithHistory = history.push;
    if (nextStep === null) {
      return redirectWithHistory(`${getPath(match.path, match.params)}/check`);
    }
    redirectWithHistory(`${getPath(match.path, match.params)}/${nextStep}`);
  }

  const onSuccess = () => {
    sessionStorage.removeItem("currLocality");
    sessionStorage.removeItem("currVillage");
    clearParams();
    queryClient.invalidateQueries("PT_CREATE_PROPERTY");
  };
  const createApplication = async () => {
    history.push(`${getPath(match.path, match.params)}/acknowledgement`);
    };

  const handleSelect = (key, data, skipStep, isFromCreateApi) => {
    if (isFromCreateApi) setParams(data);
    else if (key === "") setParams({ ...data });
    else setParams({ ...params, ...{ [key]: { ...params[key], ...data } } });
    goNext(skipStep);
  };
  const handleSkip = () => { };

  let config = [];
  newConfig = newConfig?.PermissionOfSubdivision || newConfigBPA;
  newConfig.forEach((obj) => {
    config = config.concat(obj.body.filter((a) => !a.hideInCitizen));
  });

  config.indexRoute = "land-area-details";

  useEffect(() => {
    if (!params.uiFlow || params.uiFlow?.flow !== 'Form11') {
      setParams({ ...params, ...{ uiFlow: { flow: "Form11" } } });
    }
  }, []);

  useEffect(() => {
    if (sessionStorage.getItem("isPermitApplication") && sessionStorage.getItem("isPermitApplication") == "true") {
      clearParams();
      sessionStorage.setItem("isPermitApplication", false);
    }
  }, []);

  const CheckPage = Digit?.ComponentRegistryService?.getComponent('BPAForm11CheckPage');
  const OBPSAcknowledgement = Digit?.ComponentRegistryService?.getComponent('BPAForm11Acknowledgement');
  const step1Tabs = config.filter(conf => conf.step === 1)

  return (
    <Switch>
      {config.map(routeObj => {
        const { component, route } = routeObj;
        if (!component) { return }
        let Component = component;
        if (typeof component === "string") {
          Component = Digit.ComponentRegistryService.getComponent(component);
        }
        return (
          <Route path={`${getPath(match.path, match.params)}/${route}`} key={route}>
            <Component
              {...(routeObj.step === 1 && step1Tabs && { step1Tabs })}
              onSelect={handleSelect}
              onSkip={handleSkip}
              currStep={routeObj}
              formData={params}
              config={config}
              t={t}
            />
          </Route>
        );
      })}

      <Route path={`${getPath(match.path, match.params)}/check`}>
        <CheckPage onSubmit={createApplication} formData={params} currStep={{ step: 5 }} />
      </Route>
      <Route path={`${getPath(match.path, match.params)}/acknowledgement`}>
        <OBPSAcknowledgement data={params} onSuccess={onSuccess} />
      </Route>
      <Route>
        <Redirect to={`${getPath(match.path, match.params)}/${["form11", ""].includes(currentPath) ? config.indexRoute : currentPath}`} />
      </Route>
    </Switch>
  );
};

export default NewBuildingPermit;